import { useEffect, useState } from "react";
import { FileText } from "lucide-react";
import { api } from "../lib/api";
import { toast } from "sonner";

export const openPdf = async (docId) => {
  const win = window.open("", "_blank");
  try {
    const { data } = await api.get(`/documents/${docId}/pdf`, { responseType: "blob" });
    const url = URL.createObjectURL(new Blob([data], { type: "application/pdf" }));
    if (win) win.location.href = url;
    else window.location.href = url;
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  } catch {
    if (win) win.close();
    toast.error("Impossibile aprire il documento");
  }
};

const PHASE = { full: "Ricevuta", deposit: "Ricevuta acconto", balance: "Ricevuta saldo" };

export const OrderDocuments = ({ orderId }) => {
  const [docs, setDocs] = useState([]);
  useEffect(() => {
    api.get(`/orders/${orderId}/documents`).then(({ data }) => setDocs(data)).catch(() => {});
  }, [orderId]);
  if (!docs.length) return null;
  return (
    <div className="mt-4 pt-3 border-t border-[#C9A227]/10 flex flex-wrap gap-2">
      {docs.map((d) => (
        <button
          key={d.doc_id}
          data-testid={`order-doc-${d.doc_id}`}
          onClick={() => openPdf(d.doc_id)}
          className="inline-flex items-center gap-2 text-xs font-mono-ps uppercase tracking-widest text-[#C9A227] border border-[#C9A227]/30 hover:border-[#C9A227] px-3 py-1.5 rounded-sm transition-colors"
        >
          <FileText size={12} /> {PHASE[d.phase] || "Ricevuta"} {d.number}
        </button>
      ))}
    </div>
  );
};
